import { Box, Avatar, Typography, Grid } from '@mui/material';
import ChatSignature from './ChatSignature';
import COLORS from '../../../../resources/style/Themes';
import {
  ScreenType,
  useHandleScreenSize,
} from '../../../../context_providers/screen_context/ScreenSizeProvider';
import { EmergencyMessage } from '../../../../models/Emergency/EmergencyMessage';

interface MessageCardProps {
  chatData: EmergencyMessage;
  icon: string;
  messageContent: string;
  message: string;
}

function MessageCard({
  chatData,
  icon,
  messageContent,
  message,
}: MessageCardProps) {
  const { screenType } = useHandleScreenSize();

  return (
    <Box sx={{ marginTop: '10px', overflow: 'hidden', borderRadius: '10px' }}>
      <Grid
        container
        spacing={0}
        sx={{
          backgroundColor: COLORS.MODAL_HEADER_GRAY,
          padding: '15px',
          borderRadius: 5,
        }}
      >
        <Grid size={screenType === ScreenType.LARGE ? 2 : 3}>
          <Avatar
            src={icon}
            alt="icon"
            sx={{ width: 60, height: 60 }}
            variant="square"
          />
        </Grid>
        <Grid size={screenType === ScreenType.LARGE ? 8 : 7}>
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', textAlign: 'left' }}
          >
            {messageContent}
          </Typography>
          <Typography variant="body2" sx={{ textAlign: 'left' }}>
            {message}
          </Typography>
        </Grid>
      </Grid>
      <ChatSignature chatData={chatData} />
    </Box>
  );
}

export default MessageCard;
